import { mapGetters } from 'vuex'
import { formattedDateForCountry } from 'components/shared/mixins/dateHelper'
import moment from 'moment'
import convertMinutesToHours from 'components/shared/mixins/convertMinutesToHours'
export default {
    mixins: [ convertMinutesToHours ],
    props: {
        entity: Object,
        itemType: {
            type: String,
            default: 'course',
            required: true
        }
    },
    computed: {
        ...mapGetters({
            isLive: 'Courses/isLive',
            isDigitalClassRoomTraining: 'Courses/isDigitalClassRoomTraining',
            isPodcast: 'Courses/isPodcast',
            isRecording: 'Courses/isRecording',
            getLiveEventDate: 'Courses/getLiveEventDate',
            getLiveEventTime: 'Courses/getLiveEventTime',
            digitalClassRoomTrainingByCourseId: 'Courses/getDigitalClassRoomEventsWithCourseId'
        }),

        // Courses

        instructors () {
            if (this.entity.instructors) {
                if (this.entity.instructors?.length === 0 || !this.entity.instructors) {
                    return '-'
                }
                let instructors = ''
                let limitedInstructors = this.entity.instructors.slice(0, 3)
                let remainingInstructors = this.entity.instructors.length - 3
                limitedInstructors.forEach((instructor, index, array) => {
                    if (index === array.length - 1) {
                        return instructors += instructor.name
                    }
                    return instructors += instructor.name + ', '
                })

                if (remainingInstructors > 0) {
                    instructors += '\xa0\xa0 +' + remainingInstructors
                }

                if (instructors === '') {
                    return '-'
                }

                return instructors
            }
        },
        getClosestDigitalClassRoomEvent () {
            const event = this.digitalClassRoomTrainingByCourseId(this.entity.id)
            if (!event) {
                return ''
            }
            return {
                time: moment(event.firstTrainingDateAndTime).format('HH:mm'),
                date: formattedDateForCountry(event.firstTrainingDateAndTime)
            }
        },

        // Collections and Learning paths

        isCollectionOrLearningPath () {
            return this.itemType === 'collection' || this.itemType === 'learningpath'
        },
        itemsLength () {
            if (this.isCollectionOrLearningPath) {
                return this.entity.items ? `${this.entity.items.length} ${this.getTranslationForCourseAmount(this.entity.items.length)}` : `${this.entity.courses.length} ${this.getTranslationForCourseAmount(this.entity.courses.length)}`
            }
        },
        videoDuration () {
            if (this.isDigitalClassRoomTraining(this.entity)) {
                const event = this.digitalClassRoomTrainingByCourseId(this.entity.id)

                if (!event) {
                    return
                }

                if (event.sessions.length > 1) {
                    return `${event.sessions.length} ${this.$t('DigitalClassrooms.days')}`
                }

                if (this.entity.videoDuration > 419) {
                    return `1 ${this.$t('DigitalClassrooms.days')}`
                }
            }

            if (this.entity.videoDuration % 60 === 0) {
                const hours = this.entity.videoDuration / 60
                return `${hours} ${this.$t('DigitalClassrooms.hours')}`
            }

            if (this.entity.videoDuration < 60) {
                const minutes = this.entity.videoDuration % 60
                return `${minutes} ${this.$t('DigitalClassrooms.minutes')}`
            }

            return this.convertMinutesToHours(this.entity.videoDuration || 0)
        },
        totalDuration () {
            if (this.isCollectionOrLearningPath) {
                return this.entity.coursesTotalDuration ? this.entity.coursesTotalDuration : this.entity.duration
            }
        }
    },
    methods: {
        getTranslationForCourseAmount (courseAmount) {
            if (courseAmount === 1) {
                return this.$t('Collectionitem.amount_one')
            } else {
                return this.$t('Collectionitem.amount')
            }
        }
    }
}
